import React from 'react';

import Button from './../styled/Button';
import Icon from './../styled/Icon';

const Dialogue = ({ editor, onChange, type = 'blockquote' }) => {
  if (!editor) return null;

  const { value } = editor;
  const { document } = value;
  const parent = document.getParent(value.blocks.first().key);
  const isActive = parent && parent.type === type;

  return (
    <Button
      active={isActive}
      onMouseDown={(e) => {
        e.preventDefault();
        const change = value.change();
        if (isActive) {
          change.unwrapBlock(type);
        } else {
          change.wrapBlock(type);
        }
        onChange(change);
      }}
    >
      <Icon className='fas fa-quote-left' />
    </Button>
  );
};

export default Dialogue;
